const CONSENT_KEY = 'luxe_cookie_consent';

const hasObjected = () => {
  try {
    return localStorage.getItem(CONSENT_KEY) === 'rejected'
      || navigator.globalPrivacyControl === true
      || navigator.doNotTrack === '1';
  } catch {
    return true;
  }
};

export function trackSiteEvent(eventType, { pagePath = window.location.pathname, jobId = '', sourceType = '' } = {}) {
  if (hasObjected()) return;
  const body = JSON.stringify({
    event_type: eventType,
    page_path: pagePath,
    job_id: jobId,
    source_type: sourceType,
  });

  window.fetch('/api/metrics/event', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body,
    credentials: 'same-origin',
    keepalive: true,
  }).catch(() => {});
}
